import { useQuery } from 'react-query'

import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { FinancialAccountBalanceSummary } from '@webapp/platform/banking/entities/FinancialAccountBalanceSummary/FinancialAccountBalanceSummary'
import { financialAccountQueryConfig } from '@webapp/platform/banking/query-configs/financialAccount'

type UseQueryFinancialAccountBalanceSummaryReturn = {
  balanceSummary: Nullable<FinancialAccountBalanceSummary>
  updatedAt: Nullable<Date>
  isFetching: boolean
  isError: boolean
}

export const useQueryFinancialAccountBalanceSummary = ({
  financialAccountId,
  onError,
  enabled = true,
  scaToken,
}: {
  financialAccountId: number | undefined
  onError?: () => void
  enabled?: boolean
  scaToken?: string
}): UseQueryFinancialAccountBalanceSummaryReturn => {
  const { data, dataUpdatedAt, isFetching, isError } = useQuery({
    queryKey: financialAccountQueryConfig.getBalanceSummary(scaToken).queryKey,
    queryFn: () => {
      if (!financialAccountId) return

      return financialAccountRepository.getFinancialAccountBalanceSummary(
        financialAccountId,
        scaToken
      )
    },
    onError,
    enabled: !!financialAccountId && enabled,
  })

  const balanceSummary = data?.data

  return {
    balanceSummary: balanceSummary
      ? new FinancialAccountBalanceSummary(balanceSummary)
      : null,
    updatedAt: dataUpdatedAt ? new Date(dataUpdatedAt) : null,
    isFetching,
    isError,
  }
}
